import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTIFFormData } from "../../../../hooks";
import { getValueOrBlank, displayDateAndTime } from "../../../../helper-functions";
import PhotoThumbnail from "../../../photos/PhotoThumbnail";
import { TissueTypes } from "../../../../models";
import { AutoCol } from "../../../../component-library";
import { TissueInformationFormProps } from ".";

export function TIFPostProcedureGradingCornea({ tissueId }: Readonly<TissueInformationFormProps>) {
    const {
        fetchGradingCaseFileUrls,
        caseFileUrls,
        getSuitability,
        postProcedureEval,
        postProcessingFiles,
        latestPostProcessingSlitLamp,
        postProcedureEvalSummary,
        latestPostProcessingSpecular,
        tissue,
    } = useTIFFormData({ tissueId });

    const isWholeGlobe = tissue?.tissueType?.name === TissueTypes.WholeGlobe;

    const tissueType: TissueTypes = tissue?.tissueType?.name as TissueTypes;

    useEffect(() => {
        fetchGradingCaseFileUrls(postProcessingFiles);
    }, [fetchGradingCaseFileUrls, postProcessingFiles]);

    if (!tissue) {
        return <div>No tissue found</div>;
    }

    return (
        <div>
            <Row>
                <Col>
                    <div style={{ fontWeight: "bold" }}>POST-PROCESSING:</div>
                    <div>
                        {tissueType} Tissue Number: {tissue?.number}
                    </div>
                    {!isWholeGlobe && (
                        <>
                            <div>
                                Endothelial Cell Density: {getValueOrBlank(postProcedureEval?.data?.cellDensity)}{" "}
                                Cells/sq mm
                            </div>
                            <div>Cornea Diameter: {getValueOrBlank(postProcedureEval?.data?.cornealDiameter)} mm</div>
                            <div>
                                CS Rim: {getValueOrBlank(postProcedureEval?.data?.corneoscleralRimSize1)} -{" "}
                                {getValueOrBlank(postProcedureEval?.data?.corneoscleralRimSize2)} mm
                            </div>
                            {!!postProcedureEval?.data?.clearZoneNa && <div>Primary Clear Zone: N/A.</div>}
                            {!postProcedureEval?.data?.clearZoneNa && !!postProcedureEval?.data?.newClearZone && (
                                <div>
                                    Primary Clear Zone: {postProcedureEval?.data?.newClearZone}{" "}
                                    {getValueOrBlank(postProcedureEval?.data?.clearZoneSize)} mm
                                </div>
                            )}
                            {!!postProcedureEval?.data?.endothelialNa && <div>Endothelial Clear Zone: N/A.</div>}
                            {!postProcedureEval?.data?.endothelialNa && !!postProcedureEval?.data?.endothelial && (
                                <div>
                                    Endothelial Clear Zone: {getValueOrBlank(postProcedureEval?.data?.endothelial)} mm
                                </div>
                            )}
                        </>
                    )}
                    <div>Lens: {getValueOrBlank(postProcedureEval?.data?.lensStatus)}</div>
                </Col>
                {postProcessingFiles.map((cf) => (
                    <AutoCol key={cf.id}>
                        <PhotoThumbnail
                            caseFile={cf}
                            url={caseFileUrls[cf.id]}
                            maxHeight="110px"
                            maxWidth="110px"
                            className="m-0"
                        />
                    </AutoCol>
                ))}
            </Row>
            <Row>{postProcedureEvalSummary}</Row>
            <Row>
                <Col>Suitability: {postProcedureEval?.data?.suitability?.checked === "yes" && getSuitability()}</Col>
            </Row>
            <Row>
                <Col>
                    <span className="me-2">
                        Slit Lamp Date/Time: {displayDateAndTime(latestPostProcessingSlitLamp?.createdOn)}
                    </span>
                    <span className="me-3">Slit Lamp Tech: {latestPostProcessingSlitLamp?.createdByUserName}</span>
                    <span className="me-2">
                        Specular Date/Time: {displayDateAndTime(latestPostProcessingSpecular?.createdOn)}
                    </span>
                    <span>Specular Tech: {latestPostProcessingSpecular?.createdByUserName}</span>
                </Col>
            </Row>
        </div>
    );
}
